export namespace AnalyticsHelper {
  export enum AnalyticsTimeFrames {
    THIS_WEEK = 'This week',
    LAST_7_DAYS = 'Last 7 days',
    THIS_MONTH = 'Month to date',
  }
}
